import { createApp } from 'vue'
import App from './App.vue'
import './assets/fonts/stylesheet.css';
// import './assets/urbane.css';
import './assets/style.css';

const app = createApp(App);
app.mount('#app')
